import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'app-import-wrapper',
  templateUrl: './import-wrapper.component.html',
  styleUrls: ['./import-wrapper.component.scss']
})
export class ImportWrapperComponent {

  /**
   * Coming from BulkImportComponent
   * Example:
   * validator = employeeImportValidator
   */
  @Input() validator: any;

  /**
   * Notifies Employee Step that import has finished
   */
  @Output() importCompleted = new EventEmitter<void>();

  constructor() {}

  onImportDone() {
    // Trigger event to employee-step.component
    this.importCompleted.emit();
  }
}
